// extracted by mini-css-extract-plugin
module.exports = {"formMessage":"ch_m6","formMessage_error":"ch_m7","formMessage_success":"ch_m8","formMessage_negative":"ch_m9","formMessage__icon":"ch_nb"};